'use client';

import { useImperativeHandle, forwardRef } from 'react';

const ScrollToTop = forwardRef((_, ref) => {
  useImperativeHandle(ref, () => ({
    scrollToTop: () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
  }));

  return null;
});

export default ScrollToTop;